/* NINNA — Selector de envío en el carrito (global, funciona en página y carrito lateral) */
(function () {
  if (window.__selectorEnvio) return;
  window.__selectorEnvio = true;
  var KEY = 'Tipo de envío';
  var DAC = 'Interior por DAC';
  var pendiente = null, timer = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function q(s) { return document.querySelectorAll(s); }
  function elegido() { var r = document.querySelector('[data-selector-envio] input[type=radio]:checked'); return r ? r.value : null; }
  function haySelector() { return !!document.querySelector('[data-selector-envio]'); }
  function valor(campo) {
    var v = '';
    q('[data-se-campo="' + campo + '"]').forEach(function (i) { if (i.value.trim()) v = i.value.trim(); });
    return v;
  }
  function guardar(attrs) {
    pendiente = fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .catch(function () {})
      .then(function () { pendiente = null; });
    return pendiente;
  }
  function toggleDac() {
    var esDac = elegido() === DAC;
    q('[data-se-dac]').forEach(function (b) { b.hidden = !esDac; });
  }
  function ocultarAvisos() { q('[data-se-aviso],[data-se-aviso-dac]').forEach(function (a) { a.hidden = true; }); }
  function mostrar(sel) {
    q(sel).forEach(function (a) { a.hidden = false; });
    var box = Array.prototype.find.call(q('[data-selector-envio]'), function (el) { return el.offsetParent !== null; });
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('[data-selector-envio] input[type=radio]')) return;
    q('[data-selector-envio] input[type=radio]').forEach(function (x) { x.checked = (x.value === r.value); });
    ocultarAvisos(); toggleDac();
    var attrs = {}; attrs[KEY] = r.value;
    if (r.value !== DAC) { attrs['Localidad DAC'] = ''; attrs['Agencia DAC'] = ''; }
    guardar(attrs);
  });
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i.matches || !i.matches('[data-se-campo]')) return;
    var campo = i.getAttribute('data-se-campo');
    q('[data-se-campo="' + campo + '"]').forEach(function (x) { if (x !== i) x.value = i.value; });
    q('[data-se-aviso-dac]').forEach(function (a) { a.hidden = true; });
    clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      var attrs = {}; attrs[campo] = i.value.trim(); guardar(attrs);
    }, 400);
  });
  function bloquear(e, reintentar) {
    if (!haySelector()) return false;
    var stop = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (!elegido()) { stop(); mostrar('[data-se-aviso]'); return true; }
    if (elegido() === DAC && (!valor('Localidad DAC') || !valor('Agencia DAC'))) { stop(); toggleDac(); mostrar('[data-se-aviso-dac]'); return true; }
    if (timer) {
      clearTimeout(timer); timer = null; stop();
      guardar({ 'Localidad DAC': valor('Localidad DAC'), 'Agencia DAC': valor('Agencia DAC') }).then(reintentar);
      return true;
    }
    if (pendiente) { stop(); pendiente.then(reintentar); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[name=checkout], a[href*="/checkout"]') : null;
    if (!b) return;
    bloquear(e, function () { b.click(); });
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter, f = e.target;
    var esCheckout = (s && s.name === 'checkout') || (f && /\/checkout/.test(f.getAttribute('action') || ''));
    if (!esCheckout) return;
    bloquear(e, function () { if (s) s.click(); else f.submit(); });
  }, true);
  // "Instrucciones especiales" -> "NOTAS"
  var NOTA = 'NOTAS';
  function renombrarNota() {
    q('.cart-note__label').forEach(function (l) { if (l.textContent.trim() !== NOTA) l.textContent = NOTA; });
    q('label[for="cart-note"]').forEach(function (l) { if (l.textContent.trim() !== NOTA) l.textContent = NOTA; });
  }
  // al re-renderizarse el carrito lateral, mantener visible el bloque DAC y el nombre de la nota
  new MutationObserver(function () { renombrarNota(); if (haySelector()) toggleDac(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renombrarNota); else renombrarNota();
})();
